export const caseStudies = [
  {
    slug: 'after-hours',
    no: '01',
    title: 'After Hours',
    category: 'Brand Experience',
    location: 'New York',
    role: 'Concept, design, production',
    format: 'Overnight brand experience',
    line: 'Nine rooms, one story, a city that stayed until sunrise.',
    idea: 'What if a brand story could only be told after dark? We imagined a single night unfolding room by room, each space revealing the next chapter.',
    experience: 'Guests moved through a disused printworks at their own pace. Light, sound and scent shifted from room to room, slowing the night down and pulling people deeper into the narrative.',
    heroAlt: 'Nighttime brand experience in a warehouse with guests under a glowing ceiling installation',
    heroSrc: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-feat-01.webp',
    expAlt: 'Guests walking through a dim corridor lit by violet light panels inside a printworks',
    expSrc: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-ah-exp.webp',
    gallery: [
      { alt: 'Wide view of a room filled with suspended paper sheets glowing under cool light', src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-ah-g1.webp' },
      { alt: 'Close detail of hands touching an illuminated printed installation', src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-ah-g2.webp' },
      { alt: 'Guests on a rooftop at sunrise after an overnight event', src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-ah-g3.webp' },
    ],
  },
  {
    slug: 'new-perspectives',
    no: '02',
    title: 'New Perspectives',
    category: 'Creative Summit',
    location: 'London',
    role: 'Concept, staging, show calling',
    format: 'Two-day summit in the round',
    line: 'A two-day summit staged in the round, so every voice was heard from every seat.',
    idea: 'A summit about seeing things differently should not have a front row. We removed the stage edge and placed every speaker at the centre of the room.',
    experience: 'A circular stage, a ring of seats and lighting that followed the conversation. Speakers turned, audiences leaned in, and the room felt more like a dialogue than a lecture.',
    heroAlt: 'Speaker on a minimal circular stage in front of a seated audience at a creative summit',
    heroSrc: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-work-02b.webp',
    expAlt: 'Overhead view of a circular stage surrounded by rings of seated guests',
    expSrc: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-np-exp.webp',
    gallery: [
      { alt: 'Audience in conversation between sessions in a theatre foyer', src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-np-g1.webp' },
      { alt: 'Speaker silhouetted in a spotlight seen from behind the audience', src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-np-g2.webp' },
      { alt: 'Detail of microphones and notes on a minimal stage table', src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-np-g3.webp' },
    ],
  },
  {
    slug: 'the-art-of-gathering',
    no: '03',
    title: 'The Art of Gathering',
    category: 'Private Experience',
    location: 'Copenhagen',
    role: 'Concept, set design, hosting',
    format: 'Private dinner for forty',
    line: 'Forty guests, one long table and a menu written around the stories of the people seated at it.',
    idea: 'An evening built around the guests themselves. Each course drew on a story shared by someone at the table, turning dinner into a quiet act of listening.',
    experience: 'One oak table ran the length of a Scandinavian loft. Candlelight, handmade ceramics and the blue light of dusk did most of the work, letting conversation take centre stage.',
    heroAlt: 'Long candlelit table in a Scandinavian space set for an intimate private gathering',
    heroSrc: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-work-03b.webp',
    expAlt: 'Handmade ceramic plates and candles arranged on an oak table',
    expSrc: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-ag-exp.webp',
    gallery: [
      { alt: 'Wide view of guests seated along a candlelit table at dusk', src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-ag-g1.webp' },
      { alt: 'Chef plating a course in a calm open kitchen', src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-ag-g2.webp' },
      { alt: 'Two guests laughing across the table in candlelight', src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-ag-g3.webp' },
    ],
  },
  {
    slug: 'into-the-light',
    no: '04',
    title: 'Into the Light',
    category: 'Product Launch',
    location: 'Paris',
    role: 'Concept, light design, production',
    format: 'Single-moment product reveal',
    line: 'A single beam, a held breath, and a reveal timed to the second.',
    idea: 'Strip the launch back to one moment. Darkness, silence and a single beam of light, so nothing competed with the object itself.',
    experience: 'The hall stayed almost black as guests arrived. A slow build of sound and haze led to one precise cue, when the beam opened and the room exhaled together.',
    heroAlt: 'Product reveal with a beam of white light over a podium and an audience watching in Paris',
    heroSrc: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-work-04b.webp',
    expAlt: 'Lighting technician at a console in a darkened hall before a reveal',
    expSrc: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-il-exp.webp',
    gallery: [
      { alt: 'Panoramic view of a single light beam cutting through haze in a grand hall', src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-il-g1.webp' },
      { alt: 'Sculptural podium detail under a narrow beam of light', src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-il-g2.webp' },
      { alt: 'Guests looking upward in the glow after the reveal', src: 'https://public.readdy.ai/ai/img_res/sandbox/9375ca16a27728ad5f5dab836bff4134/c823f1e9-95a6-4af6-9758-a408c949de9b_ff-il-g3.webp' },
    ],
  },
];

export const projectTypes = [
  'Brand Activation',
  'Corporate Experience',
  'Creative Production',
  'Private / Cultural Event',
  'Other',
];